import axios from './main'
import routes from './routes'

export const createDub = async (id, createData) => {
  try {
    const { data } = await axios.post(routes.createDub(id), createData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getDubs = async (id) => {
  try {
    const { data } = await axios.get(routes.getDubs(id))
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const getDub = async (id) => {
  try {
    const { data } = await axios.get(routes.getDub(id))
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const deleteDub = async (id) => {
  try {
    const { data } = await axios.delete(routes.deleteDub(id))
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
